import { FeatureCollection, GeoJsonProperties, Geometry } from 'geojson';
import { useDeepCompareMemo } from 'use-deep-compare';
import { Block } from '../../../../services/entities/impl/blfApi/schemas/block';
import { convertBlocksToFeatureCollection } from '../../../map/utils/convertBlocksToFeatureCollection';

export const useBlockGeoJsonFeatures = (
  blocks: Block[]
): FeatureCollection<Geometry, GeoJsonProperties> => {
  return useDeepCompareMemo(() => {
    return convertBlocksToFeatureCollection(blocks);
  }, [blocks]);
};
